import React from "react"

export const TriangleFillIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="10"
      viewBox="0 0 11 10"
      fill="none"
    >
      <g clipPath="url(#clip0_13063_21296)">
        <path
          // eslint-disable-next-line max-len
          d="M0.914062 8.7487L5.4974 0.832031L10.0807 8.7487H0.914062ZM5.4974 7.4987C5.61545 7.4987 5.71441 7.45877 5.79427 7.37891C5.87413 7.29904 5.91406 7.20009 5.91406 7.08203C5.91406 6.96398 5.87413 6.86502 5.79427 6.78516C5.71441 6.70529 5.61545 6.66536 5.4974 6.66536C5.37934 6.66536 5.28038 6.70529 5.20052 6.78516C5.12066 6.86502 5.08073 6.96398 5.08073 7.08203C5.08073 7.20009 5.12066 7.29904 5.20052 7.37891C5.28038 7.45877 5.37934 7.4987 5.4974 7.4987ZM5.08073 6.2487H5.91406V4.16536H5.08073V6.2487Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_13063_21296">
          <rect
            width="10"
            height="10"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
